import React from 'react'
import { observer } from 'mobx-react'
import FirmDashboardJobsViewModel from '../../FirmDashboardJobsViewer/FirmDashboardJobTableViewModel'
import { Dropdown, DropdownItem, DropdownTitle } from 'components/Dropdown'
import Icon from 'components/Icon'
import styles from './FirmDashboardTableControls.sass'

interface FirmDashboardTableControlsProps {
  vm: FirmDashboardJobsViewModel
  button: React.ReactNode
}

export default observer(function FirmDashboardTableControls({
  vm,
  button,
}: FirmDashboardTableControlsProps) {
  const columnManager = vm.columnManager
  const exportCSV = columnManager.exportJobsAsCSV

  return (
    <>
      <Dropdown autoDismiss position="bottom-end" button={button}>
        <div className={styles.tableControlsContainer}>
          <DropdownTitle>Menu</DropdownTitle>
          <FirmDashboardTableControlsItem
            icon={
              <Icon
                className={styles.tableControlsItemIcon}
                name="download"
                size={24}
              />
            }
            onClick={() => exportCSV()}
            dataTest="job-management-table-menu-export-csv"
          >
            Export CSV
          </FirmDashboardTableControlsItem>
        </div>
      </Dropdown>
    </>
  )
})

interface FirmDashboardTableControlsItemProps {
  children: React.ReactNode
  icon: React.ReactNode
  active?: boolean
  onClick?: () => void
  dataTest?: string
}

const FirmDashboardTableControlsItem = ({
  children,
  icon,
  active,
  onClick,
  dataTest,
}: FirmDashboardTableControlsItemProps) => (
  <DropdownItem
    icon={icon}
    active={active}
    onClick={onClick}
    dataTest={dataTest}
  >
    {children}
  </DropdownItem>
)
